module.exports = __webpack_public_path__ + "img/txt.b78f636a.svg";